// extracted by mini-css-extract-plugin
export default {"item":"CategoryItem_item__CaG7-","sub_a":"CategoryItem_sub_a__jiitb"};